import { NotificationFieldProps } from "./types/notificationFieldProps";
import { ReactComponent as Notification } from '../../icons/notifications.svg';
import { iconStyle } from '../shared/stylization';
import './notificationField.scss';

const NotificationField = (props: NotificationFieldProps) => {
    return (
        <div className="notificationField">
            <Notification style={iconStyle} onClick={props.onClick} />
            {props.count > 0 && <div className="notify-badge"><span>{props.count >= 100 ? "+99" : props.count}</span></div>}
        </div>
    )
}

export default NotificationField;